import React from 'react';
import classnames from 'classnames';

import StrapiButton from '../../StrapiLink/StrapiButton';
import SpeechBubble from '../../SpeechBubble';
import { RichTextField } from '../../RichTextField/RichTextField';
import { CourseCtaPanelFragment, LinkComponentFragment, Maybe, StrapiImageFragment } from '../../../../graphql.schema';
import { useImageResize } from '../../../hooks/useImageResize';
import { fullImageUrl } from '../../../lib/helpers';

export type CourseCtaPanelFragmentProps = CourseCtaPanelFragment & {
  optional_link: Maybe<{ __typename?: 'Strapi_ComponentAtomLink' } & LinkComponentFragment>;
};

export const StrapiCourseCTAPanel = ({
  image,
  description,
  speechBubbleText,
  optional_link: link,
}: CourseCtaPanelFragmentProps) => {
  const isV2 = process.env.GATSBY_IS_V2 === 'true';
  let styles = require('./index.module.scss');
  if (isV2) {
    styles = require('./index-v2.module.scss');
  }

  const { imageUrl, imageStyle, imageWrapper } = useImageResize(image as StrapiImageFragment);

  if (isV2) {
    return (
      <section className={styles.wrapper}>
        <div className="container">
          <div className={styles.content}>
            <div ref={imageWrapper} className={styles.image}>
              <img
                alt={image?.alternativeText ?? image?.caption ?? ''}
                width={image?.width ?? undefined}
                height={image?.height ?? undefined}
                style={imageStyle}
                src={fullImageUrl(imageUrl)}
                loading="lazy"
              />
            </div>
            <div className={styles.info}>
              <div className={styles.speechBubble}>
                <SpeechBubble variant="brand-a-light" speechBubbleText={speechBubbleText ?? ''} />
              </div>
              <div className={styles.infoContent}>
                <RichTextField content={`<p class="is-text-2 has-text-white mb-3">${description}</p>`} />
                {link && <StrapiButton type="secondary" key={link?.title} {...(link as LinkComponentFragment)} />}
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className={styles.wrapper}>
      <div className="columns">
        <div ref={imageWrapper} className={classnames(styles.image, 'column is-5 pb-0')}>
          <img
            alt={image?.alternativeText ?? image?.caption ?? ''}
            width={image?.width}
            height={image?.height}
            style={imageStyle}
            src={fullImageUrl(imageUrl)}
            loading="lazy"
          />
        </div>
        <div className={classnames(styles.info, 'column is-5 p-4')}>
          <SpeechBubble variant="brand-b" speechBubbleText={speechBubbleText ?? ''} />
          <p className="is-text-2 has-text-white mb-3">{description}</p>
          {link && <StrapiButton type="secondary" key={link?.title} {...(link as LinkComponentFragment)} />}
        </div>
      </div>
    </section>
  );
};
